function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  /* #46494c has no matching --dcm-* token default; locally-scoped var keeps\n     light surfaces byte-identical while re-skinning under Concierge Mode. */\n  --msh-heading-color: #46494c;\n  .concierge-mode & {\n    --msh-heading-color: var(--dcm-color-text-primary);\n  }\n  color: var(--msh-heading-color);\n  font-size: 15px;\n  font-weight: bold;\n  line-height: 1;\n  margin-bottom: ",
        ";\n  text-transform: ",
        ";\n  ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { fontSize } from 'styled-system';
/**
 * @typedef {import('styled-system').FontSizeProps} FontSizeProps
 */ var StyledHeader = /** @type {import('styled-components').ThemeStyledFunction<'h2', FontSizeProps>} */ styled.h2(_templateObject(), function(props) {
    return props.mb ? props.mb : '21px';
}, function(props) {
    return props.lowercase ? 'none' : 'uppercase';
}, fontSize);
export default StyledHeader;
